const LEGEND_ITEMS: Array<{ label: string; color: string }> = [
  { label: 'Hot', color: '#b91c1c' },
  { label: 'Warming', color: '#f97316' },
  { label: 'Neutral', color: '#94a3b8' },
  { label: 'Cooling', color: '#3b82f6' },
  { label: 'Cold', color: '#1d4ed8' },
  { label: 'No data', color: '#e2e8f0' },
];

export function MapLegend() {
  return (
    <div className="map-legend">
      <div className="map-legend__title">Market temperature</div>
      {LEGEND_ITEMS.map((item) => (
        <div className="map-legend__row" key={item.label}>
          <span className="map-legend__swatch" style={{ backgroundColor: item.color }} />
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
}
